import {
    addEmailDTO,
    authDTO,
    authNoTokenDTO,
    changePassDTO,
    forgotPassDTO,
    loginDTO,
    signInPasswordlessDTO,
    signInPasswordlessEndDTO,
    signUpDTO,
    signUpPasswordless,
    tokenValidate,
} from '.';
export const AUTHENTICATION = {
    SET_IS_AUTHENTICATED: 'AUTHENTICATION.SET_IS_AUTHENTICATED',
    SET_IS_ERROR: 'AUTHENTICATION.SET_IS_ERROR',

    SET_IS_BASE_URL_RETRIEVED: 'AUTHENTICATION.SET_IS_BASE_URL_RETRIEVED',
    ///new auth

    GET_AUTH_DATA: 'AUTHENTICATION.GET_AUTH_DATA',
    GET_AUTH_DATA_SUCCESS: 'AUTHENTICATION.GET_AUTH_DATA_SUCCESS',
    GET_AUTH_DATA_FAILURE: 'AUTHENTICATION.GET_AUTH_DATA_FAILURE',

    ROTATE_TOKEN: 'AUTHENTICATION.ROTATE_TOKEN',
    ROTATE_TOKEN_SUCCESS: 'AUTHENTICATION.ROTATE_TOKEN_SUCCESS',
    ROTATE_TOKEN_FAILURE: 'AUTHENTICATION.ROTATE_TOKEN_FAILURE',
    SIGN_IN: 'AUTHENTICATION.SIGN_IN_NEW',
    SIGN_IN_SUCCESS: 'AUTHENTICATION.SIGN_IN_NEW_SUCCESS',
    SIGN_IN_FAILURE: 'AUTHENTICATION.SIGN_IN_NEW_FAILURE',

    CHANGE_PASSWORD: 'AUTHENTICATION.CHANGE_PASSWORD',
    CHANGE_PASSWORD_SUCCESS: 'AUTHENTICATION.CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILURE: 'AUTHENTICATION.CHANGE_PASSWORD_FAILURE',
    CHANGE_PASSWORD_CLEAR: 'AUTHENTICATION.CHANGE_PASSWORD_CLEAR',

    FORGOT_PASSWORD: 'AUTHENTICATION.FORGOT_PASSWORD',
    FORGOT_PASSWORD_SUCCESS: 'AUTHENTICATION.FORGOT_PASSWORD_SUCCESS',
    FORGOT_PASSWORD_FAILURE: 'AUTHENTICATION.FORGOT_PASSWORD_FAILURE',

    FORGOT_PASSWORD_END: 'AUTHENTICATION.FORGOT_PASSWORD_END',
    FORGOT_PASSWORD_END_SUCCESS: 'AUTHENTICATION.FORGOT_PASSWORD_END_SUCCESS',
    FORGOT_PASSWORD_END_FAILURE: 'AUTHENTICATION.FORGOT_PASSWORD_END_FAILURE',

    GET_FORGOT_PASSWORD_EMAIL: 'AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL',
    GET_FORGOT_PASSWORD_EMAIL_SUCCESS: 'AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL_SUCCESS',
    GET_FORGOT_PASSWORD_EMAIL_FAILURE: 'AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL_FAILURE',

    LOGOUT_NEW_REQUEST: 'AUTHENTICATION.LOGOUT_NEW_REQUEST',
    LOGOUT_NEW_SUCCESS: 'AUTHENTICATION.LOGOUT_NEW_SUCCESS',
    LOGOUT_NEW_FAILURE: 'AUTHENTICATION.LOGOUT_NEW_FAILURE',

    TOKEN_VALIDATE: 'AUTHENTICATION.TOKEN_VALIDATEREQUEST',
    TOKEN_VALIDATE_SUCCESS: 'AUTHENTICATION.TOKEN_VALIDATESUCCESS',
    TOKEN_VALIDATE_FAILURE: 'AUTHENTICATION.TOKEN_VALIDATEFAILURE',

    SIGN_UP_NEW: 'AUTHENTICATION.SIGN_UP_NEW',
    SIGN_UP_NEW_SUCCESS: 'AUTHENTICATION.SIGN_UP_NEW_SUCCESS',
    SIGN_UP_NEW_FAILURE: 'AUTHENTICATION.SIGN_UP_NEW_FAILURE',

    CHANGE_LANGUAGE: 'AUTHENTICATION.CHANGE_LANGUAGE',

    SIGN_IN_CHECK: 'AUTHENTICATION.SIGN_IN_CHECK',
    SIGN_IN_CHECK_RESULT: 'AUTHENTICATION.SIGN_IN_CHECK_RESULT',
    SIGN_IN_CHECK_CLEAR: 'AUTHENTICATION.SIGN_IN_CHECK_CLEAR',

    SIGN_IN_PASSWORLESS: 'AUTHENTICATION.SIGN_IN_PASSWORLESS',
    SIGN_IN_PASSWORLESS_SUCCESS: 'AUTHENTICATION.SIGN_IN_PASSWORLESS_SUCCESS',
    SIGN_IN_PASSWORLESS_FAILURE: 'AUTHENTICATION.SIGN_IN_PASSWORLESS_FAILURE',

    SIGN_IN_PASSWORLESS_END: 'AUTHENTICATION.SIGN_IN_PASSWORLESS_END',
    SIGN_IN_PASSWORLESS_END_SUCCESS: 'AUTHENTICATION.SIGN_IN_PASSWORLESS_END_SUCCESS',
    SIGN_IN_PASSWORLESS_END_FAILURE: 'AUTHENTICATION.SIGN_IN_PASSWORLESS_END_FAILURE',

    SIGN_UP_NEW_PASSWORLESS: 'AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS',
    SIGN_UP_NEW_PASSWORLESS_SUCCESS: 'AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_SUCCESS',
    SIGN_UP_NEW_PASSWORLESS_FAILURE: 'AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_FAILURE',

    ADD_PHONE: 'AUTHENTICATION.ADD_PHONE',
    ADD_PHONE_SUCCESS: 'AUTHENTICATION.ADD_PHONE_SUCCESS',
    ADD_PHONE_FAILURE: 'AUTHENTICATION.ADD_PHONE_FAILURE',

    ADD_PHONE_END: 'AUTHENTICATION.ADD_PHONE_END',
    ADD_PHONE_END_SUCCESS: 'AUTHENTICATION.ADD_PHONE_END_SUCCESS',
    ADD_PHONE_END_FAILURE: 'AUTHENTICATION.ADD_PHONE_END_FAILURE',
    ADD_PHONE_CLEAR: 'AUTHENTICATION.ADD_PHONE_CLEAR',

    ADD_EMAIL: 'AUTHENTICATION.ADD_EMAIL',
    ADD_EMAIL_SUCCESS: 'AUTHENTICATION.ADD_EMAIL_SUCCESS',
    ADD_EMAIL_FAILURE: 'AUTHENTICATION.ADD_EMAIL_FAILURE',

    ADD_EMAIL_END: 'AUTHENTICATION.ADD_EMAIL_END',
    ADD_EMAIL_END_SUCCESS: 'AUTHENTICATION.ADD_EMAIL_END_SUCCESS',
    ADD_EMAIL_END_FAILURE: 'AUTHENTICATION.ADD_EMAIL_END_FAILURE',
    ADD_EMAIL_CLEAR: 'AUTHENTICATION.ADD_EMAIL_CLEAR',

    EDIT_USERNAME: 'AUTHENTICATION.EDIT_USERNAME',
    EDIT_USERNAME_SUCCESS: 'AUTHENTICATION.EDIT_USERNAME_SUCCESS',
    EDIT_USERNAME_FAILURE: 'AUTHENTICATION.EDIT_USERNAME_FAILURE',

    EDIT_USERNAME_END: 'AUTHENTICATION.EDIT_END_USERNAME',
    EDIT_USERNAME_END_SUCCESS: 'AUTHENTICATION.EDIT_USERNAME_END_SUCCESS',
    EDIT_USERNAME_END_FAILURE: 'AUTHENTICATION.EDIT_USERNAME_END_FAILURE',
    EDIT_USERNAME_CLEAR: 'AUTHENTICATION.EDIT_USERNAME_CLEAR',

    SIGN_IN_SWITCH_TO_EMAIL: 'AUTHENTICATION.SIGN_IN_SWITCH_TO_EMAIL',
    SIGN_IN_SWITCH_TO_PHONE: 'AUTHENTICATION.SIGN_IN_SWITCH_TO_PHONE',
};

export interface ISetIsAuthenticated {
    type: typeof AUTHENTICATION.SET_IS_AUTHENTICATED;
    payload: boolean;
}

export interface ISetIsError {
    type: typeof AUTHENTICATION.SET_IS_ERROR;
    payload: string;
}

export interface IBaseURLRetrieved {
    type: typeof AUTHENTICATION.SET_IS_BASE_URL_RETRIEVED;
    payload: boolean;
}
// new auth
export interface IRotateToken {
    type: typeof AUTHENTICATION.ROTATE_TOKEN;
}
export interface IRotateTokenSuccess {
    type: typeof AUTHENTICATION.ROTATE_TOKEN_SUCCESS;
    payload: authDTO;
}

export interface IRotateTokenFailure {
    type: typeof AUTHENTICATION.ROTATE_TOKEN_FAILURE;
    payload: any;
}

export interface IGetAuthData {
    type: typeof AUTHENTICATION.GET_AUTH_DATA;
}
export interface IGetAuthDataSuccess {
    type: typeof AUTHENTICATION.GET_AUTH_DATA_SUCCESS;
    payload: authNoTokenDTO;
}

export interface IGetAuthDataFailure {
    type: typeof AUTHENTICATION.GET_AUTH_DATA_FAILURE;
    payload: any;
}

export interface ISingIn {
    type: typeof AUTHENTICATION.SIGN_IN;
    payload: loginDTO;
}
export interface ISingInSuccess {
    type: typeof AUTHENTICATION.SIGN_IN_SUCCESS;
    payload: authDTO;
}

export interface ISingInFailure {
    type: typeof AUTHENTICATION.SIGN_IN_FAILURE;
    payload: string;
}

export interface IForgotPassword {
    type: typeof AUTHENTICATION.FORGOT_PASSWORD;
    payload: string;
}
export interface IForgotPasswordSuccess {
    type: typeof AUTHENTICATION.FORGOT_PASSWORD_SUCCESS;
    payload: any;
}

export interface IForgotPasswordFailure {
    type: typeof AUTHENTICATION.FORGOT_PASSWORD_FAILURE;
    payload: any;
}

export interface IForgotPasswordFinish {
    type: typeof AUTHENTICATION.FORGOT_PASSWORD_END;
    payload: forgotPassDTO;
}
export interface IForgotPasswordFinishSuccess {
    type: typeof AUTHENTICATION.FORGOT_PASSWORD_END_SUCCESS;
    payload: any;
}

export interface IForgotPasswordFinishFailure {
    type: typeof AUTHENTICATION.FORGOT_PASSWORD_END_FAILURE;
    payload: any;
}

export interface IGetForgotPasswordEmail {
    type: typeof AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL;
    payload: string;
}
export interface IGetForgotPasswordEmailSuccess {
    type: typeof AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL_SUCCESS;
    payload: string;
}

export interface IGetForgotPasswordEmailFailure {
    type: typeof AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL_FAILURE;
    payload: any;
}
export interface IChangePassword {
    type: typeof AUTHENTICATION.CHANGE_PASSWORD;
    payload: changePassDTO;
}
export interface IChangePasswordSuccess {
    type: typeof AUTHENTICATION.CHANGE_PASSWORD_SUCCESS;
    payload: any;
}

export interface IChangePasswordFailure {
    type: typeof AUTHENTICATION.CHANGE_PASSWORD_FAILURE;
    payload: number;
}
export interface IChangePasswordClear {
    type: typeof AUTHENTICATION.CHANGE_PASSWORD_CLEAR;
}

export interface ILogoutNew {
    type: typeof AUTHENTICATION.LOGOUT_NEW_REQUEST;
    payload?: { redirectTo: string; silently?: boolean };
}
export interface ILogoutNewSuccess {
    type: typeof AUTHENTICATION.LOGOUT_NEW_SUCCESS;
    payload?: string;
}

export interface ILogoutNewFailure {
    type: typeof AUTHENTICATION.LOGOUT_NEW_FAILURE;
}

export interface ISignUpNew {
    type: typeof AUTHENTICATION.SIGN_UP_NEW;
    payload: signUpDTO;
}
export interface ISignUpNewSuccess {
    type: typeof AUTHENTICATION.SIGN_UP_NEW_SUCCESS;
    payload: authDTO;
}
export interface ISignUpNewFailure {
    type: typeof AUTHENTICATION.SIGN_UP_NEW_FAILURE;
    payload: any;
}
export interface IValidateToken {
    type: typeof AUTHENTICATION.TOKEN_VALIDATE;
    payload: string;
}

export interface IValidateTokenSuccess {
    type: typeof AUTHENTICATION.TOKEN_VALIDATE_SUCCESS;
    payload: tokenValidate;
}

export interface IValidateTokenFailure {
    type: typeof AUTHENTICATION.TOKEN_VALIDATE_FAILURE;
    payload: any;
}

export interface IChangeRegisterLanguage {
    type: typeof AUTHENTICATION.CHANGE_LANGUAGE;
    payload: string;
}

export interface ISignInCheck {
    type: typeof AUTHENTICATION.SIGN_IN_CHECK;
    payload: string;
}
export interface ISignInCheckResult {
    type: typeof AUTHENTICATION.SIGN_IN_CHECK_RESULT;
    payload: { result: boolean; isEmail: boolean; reason: string };
}

export interface ISignInCheckClear {
    type: typeof AUTHENTICATION.SIGN_IN_CHECK_CLEAR;
}

export interface ISingInPasswordless {
    type: typeof AUTHENTICATION.SIGN_IN_PASSWORLESS;
    payload: signInPasswordlessDTO;
}
export interface ISingInPasswordlessSuccess {
    type: typeof AUTHENTICATION.SIGN_IN_PASSWORLESS_SUCCESS;
    payload: signInPasswordlessDTO;
}

export interface ISingInPasswordlessFailure {
    type: typeof AUTHENTICATION.SIGN_IN_PASSWORLESS_FAILURE;
    payload: string;
}

export interface ISingInPasswordlessFinish {
    type: typeof AUTHENTICATION.SIGN_IN_PASSWORLESS_END;
    payload: signInPasswordlessEndDTO;
}
export interface ISingInPasswordlessFinishSuccess {
    type: typeof AUTHENTICATION.SIGN_IN_PASSWORLESS_END_SUCCESS;
    payload: authDTO & signInPasswordlessEndDTO;
}

export interface ISingInPasswordlessFinishFailure {
    type: typeof AUTHENTICATION.SIGN_IN_PASSWORLESS_END_FAILURE;
    payload: any;
}
export interface ISignUpNewPasswordless {
    type: typeof AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS;
    payload: signUpPasswordless;
}
export interface ISignUpNewPasswordlessSuccess {
    type: typeof AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_SUCCESS;
    payload: any;
}
export interface ISignUpNewPasswordlessFailure {
    type: typeof AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_FAILURE;
    payload: any;
}

export interface IAddPhone {
    type: typeof AUTHENTICATION.ADD_PHONE;
    payload: string;
}
export interface IAddPhoneSuccess {
    type: typeof AUTHENTICATION.ADD_PHONE_SUCCESS;
    payload: any;
}
export interface IAddPhoneFailure {
    type: typeof AUTHENTICATION.ADD_PHONE_FAILURE;
    payload: any;
}

export interface IAddPhoneEnd {
    type: typeof AUTHENTICATION.ADD_PHONE_END;
    payload: { phone: string; code: string };
}
export interface IAddPhoneEndSuccess {
    type: typeof AUTHENTICATION.ADD_PHONE_END_SUCCESS;
    payload: { phone: string; code: string };
}
export interface IAddPhoneEndFailure {
    type: typeof AUTHENTICATION.ADD_PHONE_END_FAILURE;
    payload: any;
}

export interface IAddEmail {
    type: typeof AUTHENTICATION.ADD_EMAIL;
    payload: string;
}
export interface IAddEmailSuccess {
    type: typeof AUTHENTICATION.ADD_EMAIL_SUCCESS;
    payload: any;
}
export interface IAddEmailFailure {
    type: typeof AUTHENTICATION.ADD_EMAIL_FAILURE;
    payload: any;
}

export interface IAddEmailEnd {
    type: typeof AUTHENTICATION.ADD_EMAIL_END;
    payload: addEmailDTO;
}
export interface IAddEmailEndSuccess {
    type: typeof AUTHENTICATION.ADD_EMAIL_END_SUCCESS;
    payload: addEmailDTO;
}
export interface IAddEmailEndFailure {
    type: typeof AUTHENTICATION.ADD_EMAIL_END_FAILURE;
    payload: any;
}
export interface IAddEmailClear {
    type: typeof AUTHENTICATION.ADD_EMAIL_CLEAR;
}

export interface IAddPhoneClear {
    type: typeof AUTHENTICATION.ADD_PHONE_CLEAR;
}

export interface IEditUsername {
    type: typeof AUTHENTICATION.EDIT_USERNAME;
    payload: { username: string; type: 'auth0' | 'sms' };
}
export interface IEditUsernameSuccess {
    type: typeof AUTHENTICATION.EDIT_USERNAME_SUCCESS;
    payload: { username: string; type: 'auth0' | 'sms' };
}
export interface IEditUsernameFailure {
    type: typeof AUTHENTICATION.EDIT_USERNAME_FAILURE;
    payload: { code: any; type: 'auth0' | 'sms' };
}

export interface IEditUsernameEnd {
    type: typeof AUTHENTICATION.EDIT_USERNAME_END;
    payload: { username: string; type: 'auth0' | 'sms'; verificationCode: string; password: string };
}
export interface IEditUsernameEndSuccess {
    type: typeof AUTHENTICATION.EDIT_USERNAME_END_SUCCESS;
    payload: { username: string; type: 'auth0' | 'sms'; verificationCode: string; password: string };
}
export interface IEditUsernameEndFailure {
    type: typeof AUTHENTICATION.EDIT_USERNAME_FAILURE;
    payload: { code: any; type: 'auth0' | 'sms' };
}

export interface IEditUsernameClean {
    type: typeof AUTHENTICATION.EDIT_USERNAME_CLEAR;
    payload: 'sms' | 'auth0';
}

export interface ISignInSwitchToEmail {
    type: typeof AUTHENTICATION.SIGN_IN_SWITCH_TO_EMAIL;
}

export interface ISignInSwitchToPhone {
    type: typeof AUTHENTICATION.SIGN_IN_SWITCH_TO_PHONE;
}

export type AuthActionTypes =
    | ISignInSwitchToPhone
    | ISignInSwitchToEmail
    | ISetIsAuthenticated
    | IBaseURLRetrieved
    | IRotateToken
    | IRotateTokenSuccess
    | IRotateTokenFailure
    | ISingInSuccess
    | ISingInFailure
    | ISignUpNewSuccess
    | ISignUpNewFailure
    | IForgotPassword
    | IChangePassword
    | IChangePasswordSuccess
    | IChangePasswordFailure
    | IChangePasswordClear
    | ILogoutNewSuccess
    | ILogoutNewFailure
    | IGetForgotPasswordEmailSuccess
    | IGetForgotPasswordEmail
    | IChangeRegisterLanguage
    | IValidateToken
    | IValidateTokenFailure
    | IValidateTokenSuccess
    | ISignInCheckResult
    | ISignInCheckClear
    | ISingInPasswordless
    | ISingInPasswordlessFinish
    | ISingInPasswordlessSuccess
    | ISingInPasswordlessFailure
    | ISingInPasswordlessFinishSuccess
    | ISingInPasswordlessFinishFailure
    | ISignUpNewPasswordlessSuccess;
